<template>
    <section class="section">
        <div class="container">
            <h1 class="title">WEBSITE TERMS OF USE AND PRIVACY STATEMENT</h1>
            ​

            <p>
                The following Terms of Use and Privacy Policy govern your use of any website operated by Hager Environmental And Atmospheric Technologies, LLC (“HEAT”) and subsidiaries (HEAT EU).
            </p>
            <p>
                By accessing or using HEAT’s websites located at www.heatrsd.com, www.heatremotesensing.com, or any other website operated by HEAT (individually and collectively referred to herein as the “Site”) you agree to the following terms and conditions.
            </p>
            <br>
            <h2 class="title is-4">Terms of Use</h2>

            <p>
                HEAT, EDAR, and other marks on this Site are trademarks and service marks or registered trademarks or service marks of HEAT.  All material available on the Site, except where otherwise noted, is under copyright to HEAT.  HEAT reserves all rights with respect to copyright and trademark ownership of all material on the Site and will enforce such rights to the full extent of applicable law.
            </p>
            <p>
                Nothing on the Site shall be construed as granting any license or right to use any image, trademark, service mark or logo. Downloading, copying or printing individual pages and/or parts of the Site is allowed for personal use only, and will not transfer title to any software or material on the Site to you.  Explicit attribution to HEAT must be made in the event that the material, or any part thereof, is reproduced in any form, written or electronic.  Furthermore, any reproduction, re-publication or distribution of this material requires the express consent of HEAT.
            </p>
            <p>
                This Site is not directed at, or intended for distribution to or use by, any person or entity who is a citizen or resident of or located in any jurisdiction where such distribution, publication, availability or use would be contrary to applicable law or regulation or which would subject HEAT to any registration or licensing requirement within such jurisdiction. Nothing on this Site shall constitute an offer or a solicitation of an offer to buy or sell any products or services.  The information in the Site is descriptive of HEAT as a whole and the services and products described may not be suitable for you or available in the jurisdiction in which you are located.
            </p>
            ​
            <p>
                HEAT will not treat users of this Site as its clients by virtue of them accessing it.  No information herein constitutes general or specific investment, legal, tax or accounting advice of any kind.
            </p>
            ​<br>
            <h2 class="title is-4">
                No Warranty; No Liability
            </h2>
            ​
            <p>
                THE INFORMATION ON THIS SITE IS PROVIDED ON AN "AS IS," "AS AVAILABLE" BASIS. HEAT MAKES NO WARRANTY
                THAT ACCESS TO THE SITE WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT
                VIRUSES OR OTHER HARMFUL COMPONENTS WILL NOT BE TRANSMITTED IN CONNECTION WITH YOUR USE OF THE SITE.
                HEAT HEREBY EXPRESSLY DISCLAIMS, TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW AND/OR REGULATION,
                ALL WARRANTIES, EXPRESS, STATUTORY OR IMPLIED, REGARDING THE SITE AND ANY RESULTS TO BE OBTAINED FROM
                THE USE OF THE SITE AND ITS CONTENTS, INCLUDING BUT NOT LIMITED TO ALL WARRANTIES OF MERCHANTABILITY,
                NON-INFRINGEMENT, FITNESS FOR A PARTICULAR PURPOSE OR USE AND ALL WARRANTIES ARISING FROM COURSE OF
                PERFORMANCE, COURSE OF DEALING AND/OR USAGE OF TRADE OR THEIR EQUIVALENTS UNDER THE APPLICABLE LAWS
                AND/OR REGULATIONS OF ANY JURISDICTION. HEAT DOES NOT WARRANT OR GUARANTEE THE ACCURACY, TIMELINESS,
                SUITABILITY, COMPLETENESS OR AVAILABILITY OF THIS SITE OR THE INFORMATION OR RESULTS OBTAINED FROM USE
                OF IT.
            </p>
            ​
            <p>
                UNDER NO CIRCUMSTANCES AND UNDER NO THEORY OF ANY APPLICABLE LAW AND/OR REGULATION SHALL HEAT BE LIABLE
                TO ANYONE FOR ANY DAMAGES ARISING IN TORT, CONTRACT, STRICT LIABILITY OR OTHERWISE FROM ACCESS TO OR USE
                OF OR INABILITY TO ACCESS OR USE THIS SITE OR FROM ANY ACTION TAKEN OR NOT TAKEN AS A RESULT, REGARDLESS
                OF WHETHER THEY ARE DIRECT, INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES OF ANY CHARACTER,
                INCLUDING DAMAGES FOR TRADING LOSSES OR LOST PROFITS, OR FOR ANY CLAIM OR DEMAND BY ANY THIRD PARTY,
                EVEN IF HEAT KNEW OR HAD REASON TO KNOW OF THE POSSIBILITY OF SUCH DAMAGES, CLAIM OR DEMAND.
            </p>
            ​<br>
            <h2 class="title is-4">
                Links to Other Websites / Content of Other Providers
            </h2>
            ​
            <p>
                Activating certain links on this Site may cause you to leave this Site. Such links, addresses or hyperlinks are provided solely for your convenience and information. HEAT has not reviewed any of the websites linked with or connected to this Site, or which provide links to this Site, and does not accept any liability for their contents, the offered products or services or any other offers. Using links from this Site to any website not owned by HEAT is at your own risk.
            </p>
            <br>
            <h2 class="title is-4">
                Severability
            </h2>
            ​
            <p>
                Should any clause of these Terms of Use be declared void or unenforceable by any court of competent
                jurisdiction, such declaration shall have no effect on the remaining clauses hereof.
            </p>
            ​<br>
            <h2 class="title is-4">
                No Waiver
            </h2>
            ​
            <p>
                HEAT’s failure to enforce its rights hereunder shall not be deemed a waiver by it as to the subsequent
                enforcement of such rights.
            </p>
            ​<br>
            <h2 class="title is-4">
                Privacy Statement:
            </h2>
            ​
            <p>
                We know that you care how information about you is used and shared, and we appreciate your trust that we
                will do so carefully and sensibly. HEAT and its affiliates (all of which are collectively known as
                “HEAT”) do not collect personal information from you through their websites.
            </p>
            <br>
            <h2 class="title is-4">
                Cookies and Web Beacons
            </h2>
            ​
            <p>
                When you view one of our websites, we may collect some non-personal information about you. The
                collection of this non-personal information is done either through the "cookie" technology or with "web
                beacons" (also called "single-pixel gif" or "web pings"). Neither our cookies nor web beacons nor web
                log information collects any personal information. They do not contain personal information such as your
                name or email address.
            </p>
            <br>
            <div class="box">
                <h3>
                    Cookies
                </h3>
                ​
                <p>
                    When you view one of our websites or interactive advertisements, we may store some information on
                    your computer. This information will be in the form of a small text file, also called a "cookie".
                    Cookies help us in many ways to make your visit to our website more enjoyable and meaningful to you.
                    For example, cookies avoid you having to log in every time you come back to one of our websites.
                    They also allow us to tailor a website or advertisement to better match your interests and
                    preferences. Most browsers can be configured not to accept cookies or to indicate when a cookie is
                    being sent.
                </p>
                <br>
                <h3>
                    Web Beacons
                </h3>
                ​
                <p>
                    Web beacons are site instrumentation that help us to determine, for instance, whether a page has
                    been viewed or not and, if so, how many times. When you ask us to send you information on a
                    promotion or a newsletter, we may use web beacons to establish how many of the emails are actually
                    opened. In general, any electronic image viewed as part of a web page or email, including an ad
                    banner, can act as a web beacon. Third party advertising networks that serve ads onto any HEAT
                    website may use cookies and/or web beacons in their advertisements. HEAT retains no control over
                    such third-party cookies and/or web beacons and does not have access to the information related to
                    third party cookies and/or web beacons.
                </p>
            </div>

            <br>
            <h2 class="title is-4">
                Links to Other Sites
            </h2>
            ​
            <p>
                Some HEAT websites may contain links to other sites. HEAT is not responsible for the privacy practices
                or the content of such web sites. We recommend you carefully read the privacy policies of each site you
                visit.
            </p>
            <br>
            <h2 class="title is-4">
                Policy Changes
            </h2>
            ​
            <p>
                We reserve the right to make changes to this Privacy Statement from time to time. If at some time in the
                future, we wish to use your information for new unanticipated uses not previously disclosed in our
                Privacy Statement, we will post the policy changes to this section of our Privacy Statement to notify
                you of these changes and provide you with the ability to opt out of these new uses. Initially, we will
                only use information collected from the time of the policy change forward for the new purposes. However,
                after a reasonable time has transpired, we will use for the new purpose the information collected before
                the policy change from those who do not opt out.
            </p>
            <br>
            <h2 class="title is-4">
                Your Acceptance of Our Privacy Practices
            </h2>
            ​
            <p>
                By using this website or any other HEAT website or interactive banner ads, you signify your acceptance
                of this Privacy Statement, and you adhere to the terms and conditions posted on the website. If you do
                not agree with any of these terms, please do not use this site or submit any personal information. This
                English version shall always prevail in case of conflicts between it and any translations of our Privacy
                Statement. This Privacy Statement does not create or confer on any individual or on HEAT any rights, or
                impose on HEAT any obligations beyond any rights conferred or obligations imposed by applicable law or
                regulation.
            </p>
            <br>
            <h2 class="title is-4">
                Participation in Privacy Shield Framework
            </h2>
            ​
            <p>
                HEAT and its subsidiaries comply with the EU-U.S. Privacy Shield Framework and/or the Swiss-U.S. Privacy Shield  Framework(s) as set forth by the U.S. Department of Commerce regarding the collection, use, and retention of personal information transferred from the European Union, the United Kingdom, and/or Switzerland to the United States.  HEAT has certified to the Department of Commerce that it adheres to the Privacy Shield Principles.  If there is any conflict between the terms in this privacy policy and the Privacy Shield Principles, the Privacy Shield Principles shall govern.  To learn more about the Privacy Shield program, and to view our certification, please visit https://www.privacyshield.gov/.
            </p>
            <p>
            In compliance with the Privacy Shield Principles, HEAT commits to resolve complaints about our collection or use of your personal information.  European Union and/or Swiss, as applicable individuals with inquiries or complaints regarding our Privacy Shield policy should first contact HEAT at:
            </p>
            <p>
            Hager Environmental & Atmospheric Technologies (HEAT)
            Complaints Department
            539 Milwaukee Way
            Knoxville, TN 37932
            +1 865-288-7890
            Allison@heatrsd.com
            </p>
            <p>
            HEAT commits to cooperate with the panel established by the EU data protection authorities (DPAs) and/or the Swiss Federal Data Protection and Information Commissioner and comply with the advice given by the panel and/or Commissioner with regard to data transferred from the EU and/or Switzerland.
            </p>
            <p>
            The Federal Trade Commission (FTC) has jurisdiction over HEAT’s compliance with the Privacy Shield.
            </p>
            <p>
            An individual has the possibility, under certain conditions, to invoke binding arbitration for complaints regarding Privacy Shield compliance not resolved by any of the other Privacy Shield mechanisms and then link to Annex I for additional information: https://www.privacyshield.gov/article?id=ANNEX-I-introduction
            </p>
            <p>
            Annex I: Section C
An individual who decides to invoke this arbitration option must take the following steps prior to initiating an arbitration claim: (1) raise the claimed violation directly with the organization and afford the organization an opportunity to resolve the issue within the timeframe set forth in Section III.11(d)(i) of the Principles; (2) make use of the independent recourse mechanism under the Principles, which is at no cost to the individual; and (3) raise the issue through their Data Protection Authority to the Department of Commerce and afford the Department of Commerce an opportunity to use best efforts to resolve the issue within the timeframes set forth in the Letter from the International Trade Administration of the Department of Commerce, at no cost to the individual. This arbitration option may not be invoked if the individual’s same claimed violation of the Principles (1) has previously been subject to binding arbitration; (2) was the subject of a final judgment entered in a court action to which the individual was a party; or (3) was previously settled by the parties.
In addition, this option may not be invoked if an EU Data Protection Authority or the Commissioner (1) has authority under Sections III.5 or III.9 of the Principles; or (2) has the authority to resolve the claimed violation directly with the organization. A DPA’s/the Commissioner's authority to resolve the same claim against an EU or a Swiss data controller does not alone preclude invocation of this arbitration option against a different legal entity not bound by the DPA/Commissioner's authority.
            </p>
            <br>
            <h2 class="title is-4">
                Data Integrity and Purpose Limitation
            </h2>
            <p>
            We only collect Personal Data that is relevant to providing our Services. We process Personal Data compatible with us providing Services. We take reasonable steps to ensure that the Personal Data received under the Privacy Shield is needed for HEAT’s Services, accurate, complete, and current.
            </p>
            <h2 class="title is-4">
                Choice
            </h2>
            <p>
            For Personal Data and Sensitive Personal Data, HEAT will offer clients the opportunity to choose (opt-in) whether Personal Data is (a) to be disclosed to a third party, or (b) to be used for a purpose other than the purpose for which it was originally collected or subsequently authorized by the individual. In other cases, where Personal Data is incorporated in data sets transferred from institutional customers, consent will be obtained by those institutional customers. HEAT will provide reasonable mechanisms to exercise choices.
            </p>
            <h2 class="title is-4">
            Data Integrity
            </h2>
            <p>
            HEAT will use Personal Data only in ways that are compatible with the purposes for which it was collected or subsequently authorized by the individual or institutional entity client. HEAT will take reasonable steps to ensure that Personal Data is relevant to its intended use. We will only collect and store Personal Data that is relevant to fulfill the purpose of the request.
            </p>
            <h2 class="title is-4">
                Transfers to Third Parties
            </h2>
            <p>
            In the rare event that a third party must be used, HEAT will obtain assurances from an independent third party subcontractors that they will safeguard Personal Data consistently with this Policy. Where HEAT has knowledge that an agent is using or disclosing Personal Data in a manner contrary to this Policy, HEAT will take reasonable steps to prevent or stop the use or disclosure.
            </p>
            <h2 class="title is-4">
                Onward Transfers of Personal Data
            </h2>
            <p>
            We will not transfer Personal Information originating in the EU to third parties unless such third parties have entered into an agreement in writing with us requiring them to provide at least the same level of privacy protection to your Personal Information as required by the Principles of the EU-U.S. Privacy Shield Framework and the Swiss-U.S. Privacy Shield Framework. We will only transfer Personal Information to cloud service providers who need the information in order to provide services to or perform activities on Our behalf. In cases of onward transfer to third parties of data of EU individuals received pursuant to the EU-U.S. Privacy Shield and the Swiss-U.S. Privacy Shield, HEAT is potentially liable.
            </p>
            <h2 class="title is-4">
                Access to Personal Data
            </h2>
            <p>
            Our Privacy Policy explains how you may access and/or submit requests to review, correct, update, suppress, or delete Personal Data. You can ask to review and correct Personal Data that we maintain about you by sending a written request through the www.heatremotesensing.com/contact page. We may limit or deny access to Personal Data where providing such access is unreasonably burdensome, expensive under the circumstances, or as otherwise permitted by the Privacy Shield Principles.
            </p>
            <h2 class="title is-4">
                Lawful Requests
            </h2>
            <p>
            We may need to disclose Personal Data in response to lawful requests by public authorities, for law enforcement or national security reasons, or when such action is necessary to comply with a judicial proceeding or court order, or when otherwise required by law. We do not offer an opportunity to opt out from this category of disclosure.
            </p>
            <p>
                Revised January 2020
            </p>
            <p>
                © 2020 Hager Environmental and Atmospheric Technologies, LLC. All rights reserved.
            </p>
        </div>
    </section>
</template>

<script>
    export default {
        name: "PrivacyPolicy"
    }
</script>

<style scoped>

</style>
